module.exports = __webpack_public_path__ + "static/media/retail (2).728e0541.svg";